export const DIAGRAMS_CACHE_NAME = "diagrams-v1";
